import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	card: {
		paddingLeft: token('space.050'),
		paddingRight: '0',
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		width: '100%',
		height: '100px',
		backgroundColor: 'transparent',
	},
	skeletonPreview: {
		height: '70px',
		width: '120px',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.large'),
	},
	placeholderTitle: {
		height: '16px',
		width: '100%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.small'),
	},
	placeholderSubtitle: {
		height: '16px',
		width: '60%',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.small'),
	},
	skeletonAvatar: {
		height: '16px',
		width: '16px',
		minWidth: '16px',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.small'),
	},
	fullWidth: {
		width: '100%',
	},
});

export const SnippetPanelItemSkeleton = (): React.JSX.Element => {
	return (
		<Box xcss={styles.card}>
			<Inline xcss={styles.fullWidth} alignInline="start" alignBlock="center" space="space.150">
				<Box xcss={styles.skeletonPreview} />
				<Stack xcss={styles.fullWidth} alignInline="start" alignBlock="center" space="space.075">
					<Box xcss={styles.placeholderTitle} />
					<Inline xcss={styles.fullWidth} alignInline="start" alignBlock="center" space="space.050">
						<Box xcss={styles.skeletonAvatar} />
						<Box xcss={styles.placeholderSubtitle} />
					</Inline>
				</Stack>
			</Inline>
		</Box>
	);
};
